<template>
	<div class="col-12">
        <h4>Elegir Nuevo Estatus</h4>
        <C020TiposEstatusDevolucion
            :class="[parametros_EstatusDevolucion.esInformativo ? 'catalogoInformativo' : '']"
              v-on:valorParaElPadre="cambioDeEstatusDevolucionEvento"
              v-on:valorParaElPadrePrimerElemento="cambioDeEstatusDevolucion"
              :prefijo="enumeraciones.etiquetasDeHTML.Select" 
              :tipo="enumeraciones.tiposDeSelect.Seleccione" 
              :parametros="parametros_EstatusDevolucion.parametros"
              :valorDefinido="parametros_EstatusDevolucion.estatusDevolucionId"
              :key="parametros_EstatusDevolucion.key"
        ></C020TiposEstatusDevolucion>
      <br>
      <div class="row  mt-3">
      	<div  class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1">
        	<button class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosGuardar_btn" @click='ejecutaLaFuncion()'><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>          
      	</div>
      	
      	<div  class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 pb-1 text-right">
          	<button class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosGuardar_btn" @click='quitarMenu()'><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>          
      	</div>
      	
      </div>
  </div>
</template>
<script>
import Vue from 'vue'
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import comun from "@/../static/js/comun"
import func from '../Comun/Funciones/comun.js'
import api from '@/../static/js/api'
import axios from 'axios'

export default {
	data(){
		return{	
        	parametros_EstatusDevolucion: {
         		key: "",
          		estatusDevolucionId: 2,
          		parametros: {},
          		esInformativo: false
        	},
        	enumeraciones,
		}
	},
	props:{
		AccionesMostrar: Object,
		AccionesPago: Object,
		catalogos: Array,
      	elementosAConservar: Object,
      	ejecutaLaFuncion: Function,
      	quitarMenu: Function
	},
	components:{
      	C020TiposEstatusDevolucion: catalogos.SIVAC.C020TiposEstatusDevolucion
	},
	beforeMount(){
		if(this.elementosAConservar.estatusdevolucion && this.elementosAConservar.estatusdevolucion.length > 0){
          this.parametros_EstatusDevolucion.parametros.elementosAConservar = this.elementosAConservar.estatusdevolucion;
          this.parametros_EstatusDevolucion.key = "elementosAConservar_" + this.elementosAConservar.estatusdevolucion.length;     
        }
	},
	methods:{
		// Estatus Devolucion

      /**
       * Método encargado de actualizar/cambiar el campo Titulo del Remitente
       * @param {event.target} datos [datos: nuevo valor del Titulo del Remitente]
       */
      cambioDeEstatusDevolucionEvento(datos) {
       this.cambioDeEstatusDevolucion(parseInt(datos.target.value));
      },

      /**
       * Método encargado de actualizar/cambiar el id de Titulo del Remitente
       * @param {int} id [id: identificador del Titulo del Remitente]
       */
      cambioDeEstatusDevolucion(id){
        this.parametros_EstatusDevolucion.estatusDevolucionId = id; 
      },


      // Estatus Devolucion


		actualizarEstatusDevolucion:function(actualizarDevolucion){
			const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
			const parametros = {
	  			DevolucionId : actualizarDevolucion.DevolucionId,
	  			EstatusDevolucionId: this.parametros_EstatusDevolucion.estatusDevolucionId,
	  			NumeroCheque : actualizarDevolucion.NumeroCheque
	  		}

			return axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.ActualizarEstatusDevolucion, parametros, headerPeticion)
	  		.then(respuesta => {
	  		if (respuesta.data.SiHayError) {
	  			console.log(respuesta);

	  			comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
	  		} else {
				this.$parent.limpiarTablaResultados();
	  			this.$parent.buscarImputadoAPI();
	  			comun.mensajeDeAlerta('Estatus Actualizado Correctamente', null, null);

          	}         
     		})
     		.catch(e => {
	  			comun.SeEstaCargandoInformacion(false);
	  			console.log("No Hay Respuesta del Servidor" + e);
	  			comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
	  		}); 
		},
	}
}
	
</script>
<style scoped>
  .btn-buscar{
    background-color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Caja/CambiarEstatusDevolucion.vue